// src/lib/firebase.js
// ─────────────────────────────────────────────────────────
// Central Firebase initialization. Import from here everywhere.
// Never import firebase directly in components.
// ─────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, signInWithCustomToken, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);

// The Firestore collection root for this app.
// All data lives under: artifacts/{APP_ID}/users/{uid}/...
export const APP_ID = process.env.REACT_APP_APP_ID || 'expense-tracker-v1';

export { signInAnonymously, signInWithCustomToken, onAuthStateChanged };